module.exports = __webpack_public_path__ + "static/media/boring-bg.9078d4bd.jpg";